import { render, staticRenderFns } from "./ProviderCardSkeleton.vue?vue&type=template&id=3abc3fbb&scoped=true"
import script from "./ProviderCardSkeleton.vue?vue&type=script&lang=js"
export * from "./ProviderCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ProviderCardSkeleton.vue?vue&type=style&index=0&id=3abc3fbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abc3fbb",
  null
  
)

export default component.exports